// extracted by mini-css-extract-plugin
module.exports = {"removeFromCartButton":"RemoveFromCartButton_removeFromCartButton__zL8ZZ"};
module.exports.__checksum = "99026e36ecda"
